import _ from 'lodash';

export function getMappedValue(data: any, path: string): any {
  return resolveMappings(data, path, true);
}

export function setMappedValue(data: any, path: string, value: any): any {
  resolveMappings(data, path, false, value);
}

function resolveMappings(data: any, path: string, isGet: boolean, value?: any): any {
  let i = 0;

  while (i < path.length) {
    const mappingF = path.indexOf('{', i);
    if (mappingF !== -1) {
      const mappingE = path.indexOf('}', i);
      const part = path.substring(i, mappingF);
      const [mapKey, mapValue] = path.substring(mappingF + 1, mappingE).split(':');
      i = mappingE + 2; // next plus possible ignored dot
      let arr = _.get(data, part);
      if (!arr) {
        if (isGet) {
          return undefined;
        }
        arr = [];
        _.set(data, part, arr)
      }

      let obj = arr.find(el => el[mapKey] === mapValue);
      if (!obj) {
        if (isGet) {
          return undefined;
        }
        obj = {
          [mapKey]: mapValue
        };
        arr.push(obj);
      }
      data = obj;
    } else {
      break;
    }
  }
  if (i !== 0) {
    path = path.substring(i);
  }
  if (isGet) {
    return path ? _.get(data, path) : data;
  } else {
    return _.set(data, path, value);
  }
}
